import React from 'react';
import {RouterProvider, createBrowserRouter} from 'react-router-dom';
import './App.css';
import EventPage from './components/EventPage/EventPage';
import {ApolloClient, InMemoryCache, ApolloProvider} from '@apollo/client';
import {ToastContainer} from 'react-toastify';
import {ThemeProvider, createTheme} from '@mui/material';
import {cyan} from '@mui/material/colors';
import ResultsPage from 'components/EventPage/ResultsPage';
import EventScrollPage from 'components/EventPage/EventScrollPage';

const apolloClient = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL,
  cache: new InMemoryCache({
    addTypename: false
  })
});

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#ff0066'
    },
    secondary: {
      main: cyan[500]
    }
  }
});

const App = () => {
  const routes = [
    {
      path: '/:slug',
      element: <EventPage />,
      children: [
        {
          path: '/:slug/:category',
          element: <ResultsPage />
        }
      ]
    },
    {
      path: '/scroll/:slug',
      element: <EventScrollPage />
    }
  ];

  const router = createBrowserRouter(routes);

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={defaultTheme}>
        <RouterProvider router={router} />
        <ToastContainer position="top-center" autoClose={3000} theme="light" />
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default App;
